/* eslint-disable jsx-a11y/anchor-is-valid */

import clsx from 'clsx'
import {FC} from 'react'
import {useTranslation} from 'react-i18next'
import {SetUserLanguage} from '../../../../redux/Slice/userSlice'
import {useAppDispatch} from '../../../../redux/hooks'
import {showErrorMessage} from '_metronic/helpers/swalHelper'

const languages = [
  {lang: 'fr', name: 'Français', short: 'FR'},
  {lang: 'de', name: 'Deutsch', short: 'DE'},
  {lang: 'it', name: 'Italiano', short: 'IT'},
  {lang: 'en', name: 'English', short: 'EN'},
  {lang: 'es', name: 'Español', short: 'ES'},
  {lang: 'pt', name: 'Português', short: 'PT'},
  {lang: 'sq', name: 'Shqip', short: 'SQ'},
  {lang: 'tr', name: 'Türkçe', short: 'TR'},
  {lang: 'ar', name: 'العربية', short: 'AR'},
  {lang: 'fa', name: 'فارسی', short: 'FA'},
  {lang: 'ps', name: 'پښتو', short: 'PS'},
  {lang: 'ur', name: 'اردو', short: 'UR'},
  {lang: 'hi', name: 'हिन्दी', short: 'HI'},
]

const Languages: FC = () => {
  const {i18n, t} = useTranslation()
  const dispatch = useAppDispatch()

  // Handles values such as "fr-FR", "en-US", etc.
  const currentLangCode = i18n.language?.split('-')[0] || 'fr'

  const currentLanguage = languages.find((x) => x.lang === currentLangCode) || languages[0]

  const handleChangeLanguage = (lang: string) => {
    if (lang === currentLangCode) {
      return
    }

    dispatch(SetUserLanguage(lang)).then((res) => {
      if (res.meta.requestStatus === 'fulfilled') {
        i18n.changeLanguage(lang).then(() => {
          window.location.reload()
        })
      } else if (res.meta.requestStatus === 'rejected') {
        showErrorMessage(t('MESSAGES.SERVER_ERROR'))
      }
    })
  }

  return (
    <div
      className='menu-item px-5'
      data-kt-menu-trigger='hover'
      data-kt-menu-placement='left-start'
      data-kt-menu-flip='bottom'
    >
      {/* Current Language */}
      <a href='#' className='menu-link px-5'>
        <span className='menu-title position-relative'>
          <span className='fa fa-globe px-1'></span>
          {t('GLOBAL.LANGUAGE')}
          <span className='fs-8 rounded bg-default px-3 ms-2'>{currentLanguage.name}</span>
        </span>
      </a>

      {/* Languages Dropdown */}
      <div className='menu-sub menu-sub-dropdown w-200px py-4'>
        {languages.map((language) => (
          <div
            className='menu-item px-3'
            key={language.lang}
            onClick={() => handleChangeLanguage(language.lang)}
          >
            <a
              href='#'
              className={clsx('menu-link d-flex align-items-center px-5', {
                active: language.lang === currentLangCode,
              })}
            >
              <span className='symbol symbol-20px mx-3'>{language.name}</span>

              {language.lang === currentLangCode && (
                <span className='ms-auto'>
                  <i className='fa fa-check text-success fs-8'></i>
                </span>
              )}
            </a>
          </div>
        ))}
      </div>
    </div>
  )
}

export {Languages}
